module.exports = __webpack_public_path__ + "static/img/190315-gene-copy.a4337df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190315-gene-copy.jpg
// module id = XgjG
// module chunks = 0